export const findStepApp = (step, apps = []) => {
  const stepAppIsNull = ['null', 'undefined']?.includes(String(step?.appVersion));
  if (stepAppIsNull) {
    const matches = apps?.filter((n) => n?.id === step?.appId);
    return matches?.find((n) => n?.version === 'draft') || matches?.[0];
  }

  return apps?.find((n) => n?.id === step?.appId && String(n?.version) === String(step?.appVersion || '0'));
};
